import { render, staticRenderFns } from "./jicha.vue?vue&type=template&id=1b6fd467&scoped=true&"
import script from "./jicha.vue?vue&type=script&lang=js&"
export * from "./jicha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6fd467",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/thScoreShop/thScoreAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b6fd467')) {
      api.createRecord('1b6fd467', component.options)
    } else {
      api.reload('1b6fd467', component.options)
    }
    module.hot.accept("./jicha.vue?vue&type=template&id=1b6fd467&scoped=true&", function () {
      api.rerender('1b6fd467', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/systemCreator/systemConfig/bonusConfig/bounsCond/jicha.vue"
export default component.exports